export const dateOnly = (value) => value ? new Date(value).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—";
export const dateTime = (value) => value ? new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—";
export const formatStatus = (value) => {
  const text = String(value || "unknown").replaceAll("_", " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
};
export const displayName = (user) => [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.username || user?.email || "User";

// Amounts are stored in the currency's minor unit (paise, cents).
export const money = (amount, currency = "INR") => {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format((Number(amount) || 0) / 100);
  } catch {
    return `${currency} ${((Number(amount) || 0) / 100).toFixed(2)}`;
  }
};

export const paymentGroupLabels = { successful: "Successful", pending: "Pending", failed: "Failed" };

const units = [["year", 31536000], ["month", 2592000], ["week", 604800], ["day", 86400], ["hour", 3600], ["minute", 60]];
export const relativeTime = (value, now = Date.now()) => {
  if (!value) return "—";
  const seconds = Math.round((new Date(value).getTime() - now) / 1000);
  if (!Number.isFinite(seconds)) return "—";
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size) return formatter.format(Math.round(seconds / size), unit);
  }
  return "just now";
};
